import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var golfIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.477 23.957a1.11 1.11 0 0 1-.417-.08l-1.003-.407c-.533-.216-.801-.76-.625-1.264l1.691-5.74c.002-.597-.559-1.194-1.151-1.825-.759-.809-1.621-1.726-1.556-2.94l.018-.356 8.15-3.693c.669-.301 1.482-.06 1.818.542l-8.607 3.901c.127.603.656 1.167 1.211 1.757.754.806 1.536 1.637 1.467 2.738l-.022.122-1.681 5.709.511.207c1.648-4.483 2.685-5.34 3.059-5.497l.475-.201.334.363c.481.52 1.832 4.044 2.229 5.113l.503-.218-.126-.46c-1.248-4.566-1.764-6.457-2.134-6.816-.698-.748-1.079-1.748-1.416-2.629-.177-.463-.25-.864-.417-1.128l1.129-.553c.228.364.371.765.568 1.284.299.78.637 1.668 1.15 2.22.586.568.942 1.866 2.435 7.33l.195.713c.113.413-.111.841-.536 1.025l-.957.416c-.346.148-.702.163-1.011.043a.976.976 0 0 1-.573-.58 64.695 64.695 0 0 0-1.704-4.242c-.412.64-1.104 1.945-2.028 4.503a.975.975 0 0 1-.567.564 1.102 1.102 0 0 1-.412.08"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.802 8.958 8.294 2.163c-.54 1.043-1.166 1.468-1.253 1.524l-.526.336-.426-.456c-.377-.403-.528-.895-.429-1.384C5.89 1.056 7.402.333 7.702.199L8.152 0l8.63 7.886-.98 1.072Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.44 5.615c-.715.32-1.027 1.182-.696 1.919.342.762 1.441 1.494 2.096 1.2.657-.295.84-1.603.497-2.365-.33-.737-1.18-1.075-1.897-.754m1.867 4.158c-1.277.574-2.999-.508-3.572-1.786-.589-1.31-.033-2.841 1.238-3.412 1.272-.57 2.785.03 3.373 1.34.574 1.279.24 3.284-1.039 3.858"
})));

export { golfIcon as default };
//# sourceMappingURL=golfIcon.js.map
